import React from 'react';
import Web3 from 'web3';
import BI from 'big-integer';
import RTZ from 'remove-trailing-zeros'

import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/core";

import { SupportedTokens, SwapContracts, SwapContractABI, TokenContractABI } from "../../Data/ContractData";

import "./swapDetail.css";

class SwapDetail extends React.Component {

  /*
    tokenSelected
    0 : APIX
    1 : wDASH -> WETH
    2 : wXZC -> wDASH
  */

  constructor(props) {
    super(props);

    this.state = {
      isMetamaskConnected: false,
      isSwapDataLoaded: false,

      userAccount: "",
      fromTokenIndex: 0,
      toTokenIndex: 0,

      swapDetail: {
        isSwapCancelled: false,
        isSwapFinished: false,
        isSwapOpened: true,
        swapOrderID: "0",
        swapCreator: "0x0000000000000000000000000000000000000000",
        swapTaker: "0x0000000000000000000000000000000000000000",
        fromTokenAmount: "0",
        toTokenAmount: "0",
      },

      requirements: {
        creatorBalance: 0,
        creatorAllowance: 0,
        takerBalance: 0,
        takerAllowance: 0,
        checkResult: [false, false, false, false],
      },

      swapPair: 0,
    }
  }

  web3 = null;

  tokenInfo = [
    {
      tokenName: "APIX",
      tokenIcon: "tokenicon_apix.svg"
    },
    {
      tokenName: "WETH",
      tokenIcon: "tokenicon_weth.svg"
    },
    {
      tokenName: "wDASH",
      tokenIcon: "tokenicon_dash.svg"
    },
    /*
    {
      tokenName: "wXZC",
      tokenIcon: "tokenicon_xzc.svg"
    },
    */
  ]

  pairInfo = [
    {
      tokenNameFrom: "APIX",
      tokenNameTo: "WETH",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_weth.svg",
    },
    {
      tokenNameFrom: "APIX",
      tokenNameTo: "wDASH",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_dash.svg",
    },
    {
      tokenNameFrom: "WETH",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_weth.svg",
      tokenIconTo: "tokenicon_apix.svg",
    },
    {
      tokenNameFrom: "WETH",
      tokenNameTo: "wDASH",
      tokenIconFrom: "tokenicon_weth.svg",
      tokenIconTo: "tokenicon_dash.svg",
    },
    {
      tokenNameFrom: "wDASH",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_dash.svg",
      tokenIconTo: "tokenicon_apix.svg",
    },
    {
      tokenNameFrom: "wDASH",
      tokenNameTo: "WETH",
      tokenIconFrom: "tokenicon_dash.svg",
      tokenIconTo: "tokenicon_weth.svg",
    },
  ]

  CC = (val) => {
    val = String(val);
    let temp = BI(val).divmod("1000000000000000000");
    let apt = temp.remainder.toString();
    let aptLen = apt.length;

    for (let i = 0; i < 18 - aptLen; i++) {
      apt = "0" + apt;
    }

    let xpt = [temp.quotient.toString(), apt]
    return RTZ(xpt[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (xpt[1] ? "." + xpt[1] : ""));
  }

  loadSwapDetail = async () => {
    //if (this.state.tokenSelected[0] == 0 && this.state.tokenSelected[1] == 1) selectedSwapPair = 0;
    //if (this.state.tokenSelected[0] == 0 && this.state.tokenSelected[1] == 2) selectedSwapPair = 1;
    //if (this.state.tokenSelected[0] == 1 && this.state.tokenSelected[1] == 0) selectedSwapPair = 2;
    //if (this.state.tokenSelected[0] == 1 && this.state.tokenSelected[1] == 2) selectedSwapPair = 3;
    //if (this.state.tokenSelected[0] == 2 && this.state.tokenSelected[1] == 0) selectedSwapPair = 4;
    //if (this.state.tokenSelected[0] == 2 && this.state.tokenSelected[1] == 1) selectedSwapPair = 5;

    //console.log(SupportedTokens);
    //console.log(SwapContracts);
    //console.log(SwapContractABI);
    //let apix_to_wdash_contract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[0].contractAddr);
    //let apix_to_wxzc_contract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[1].contractAddr);

    let selectedSwapPair = 0;
    /*old
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wXZC") selectedSwapPair = 1;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "wDASH-wXZC") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wXZC-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wXZC-wDASH") selectedSwapPair = 5;
    */

    if (this.props.match.params.pair === "APIX-WETH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 1;
    if (this.props.match.params.pair === "WETH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "WETH-wDASH") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wDASH-WETH") selectedSwapPair = 5;


    /*
    let selectedContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[selectedSwapPair].contractAddr);
    let tSwapDetail = await selectedContract.methods.SwapOrders("0x0").call();

    this.setState({
      tSwapDetail: tSwapDetail,
      swapPair: selectedSwapPair,
      isSwapDataLoaded: true,
    })
    */
    let selectedContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[selectedSwapPair].contractAddr);
    let swap_count = await selectedContract.methods.swapCount().call();

    /*
    let swap_verification = [];
    for(let i = 0; i < 10; i++) {
      swap_verification.push(await selectedContract.methods.isSwapOrderExecutable(i).call());
    }
    console.log(swap_verification)
    */

    let swapList = [];
    for (let i = 0; i < swap_count; i++) {
      let tmpCallData = await selectedContract.methods.SwapOrders(i).call();
      //inversion to show exact value
      let tmpVar = tmpCallData.fromTokenAmount;
      tmpCallData.fromTokenAmount = tmpCallData.toTokenAmount;
      tmpCallData.toTokenAmount = tmpVar;
      //inversion to show exact value
      swapList.push(tmpCallData);
    }

    /*
    for (let i = 0; i < swap_count; i++) {
      swapList.push(await selectedContract.methods.SwapOrders(i).call());
    }
    */

    this.setState({
      swapDetail: swapList[this.props.match.params.uid],
      swapPair: selectedSwapPair,
    })

    this.loadTokenDetail();
  }

  loadTokenDetail = async () => {

    let fromTokenIndex = 0;
    let toTokenIndex = 1;

    if (this.state.swapPair === 0) {
      fromTokenIndex = 0;
      toTokenIndex = 1;
    }
    if (this.state.swapPair === 1) {
      fromTokenIndex = 0;
      toTokenIndex = 2;
    }
    if (this.state.swapPair === 2) {
      fromTokenIndex = 1;
      toTokenIndex = 0;
    }
    if (this.state.swapPair === 3) {
      fromTokenIndex = 1;
      toTokenIndex = 2;
    }
    if (this.state.swapPair === 4) {
      fromTokenIndex = 2;
      toTokenIndex = 0;
    }
    if (this.state.swapPair === 5) {
      fromTokenIndex = 2;
      toTokenIndex = 1;
    }


    let fromTokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[fromTokenIndex].contractAddr);
    let toTokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[toTokenIndex].contractAddr);

    /*
      totoken & fromtoken is based on TAKER'S VIEW!!!!!!!!!!!!!!!!!!!!
      totoken & fromtoken is based on TAKER'S VIEW!!!!!!!!!!!!!!!!!!!!
      totoken & fromtoken is based on TAKER'S VIEW!!!!!!!!!!!!!!!!!!!!
    */

    let creatorBalance = await toTokenContract.methods.balanceOf(this.state.swapDetail.swapCreator).call();
    let creatorAllowance = await toTokenContract.methods.allowance(this.state.swapDetail.swapCreator, SwapContracts[this.state.swapPair].contractAddr).call();

    let takerBalance = await fromTokenContract.methods.balanceOf(this.state.userAccount).call();
    let takerAllowance = await fromTokenContract.methods.allowance(this.state.userAccount, SwapContracts[this.state.swapPair].contractAddr).call();

    let checkList = [false, false, false, false]

    if ((BI(creatorBalance).compare(this.state.swapDetail.toTokenAmount)) !== -1) checkList[0] = true;
    if ((BI(creatorAllowance).compare(this.state.swapDetail.toTokenAmount)) !== -1) checkList[1] = true;
    if ((BI(takerBalance).compare(this.state.swapDetail.fromTokenAmount)) !== -1) checkList[2] = true;
    if ((BI(takerAllowance).compare(this.state.swapDetail.fromTokenAmount)) !== -1) checkList[3] = true;

    //console.log(BI(creatorBalance).compare(this.state.swapDetail.toTokenAmount))
    //console.log(BI(creatorAllowance).compare(this.state.swapDetail.toTokenAmount))
    //console.log(BI(takerBalance).compare(this.state.swapDetail.fromTokenAmount))
    //console.log(BI(takerAllowance).compare(this.state.swapDetail.fromTokenAmount))


    this.setState({
      fromTokenIndex,
      toTokenIndex,

      requirements: {
        creatorBalance,
        creatorAllowance,
        takerBalance,
        takerAllowance,
        checkResult: checkList
      },

      isSwapDataLoaded: true,
    })

    console.log(this.state);
    console.log(this.props);
    console.log(SupportedTokens[fromTokenIndex]);
    console.log(SupportedTokens[toTokenIndex])
  }

  getSwapStatus = () => {
    //isSwapCancelled: false,
    //isSwapFinished: false,
    //isSwapOpened: true,

    if (this.state.swapDetail.isSwapCancelled) {
      return "Cancelled ❌"
    }
    if (this.state.swapDetail.isSwapFinished) {
      return "Finished ❌"
    }
    if (this.state.swapDetail.isSwapOpened) {
      return "Opened ✔️"
    }
    else {
      return "N/A"
    }
  }

  changeAllowance = async (mode, target) => {
    let swapContractAddress = SwapContracts[this.state.swapPair].contractAddr;
    let tokenContract = null;
    let modifiedValue = null;

    if (target === "FROM") {
      tokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[this.state.fromTokenIndex].contractAddr);
    } else if (target === "TO") {
      tokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[this.state.toTokenIndex].contractAddr);
    }

    if (mode === "APPLY" && target === "FROM") {
      modifiedValue = Math.ceil(this.state.swapDetail.fromTokenAmount);
      modifiedValue = BI(modifiedValue + 1);
    } else if (mode === "APPLY" && target === "TO") {
      modifiedValue = Math.ceil(this.state.swapDetail.toTokenAmount);
      modifiedValue = BI(modifiedValue + 1);
    } else if (mode === "REMOVE") {
      modifiedValue = "0"
    }
    let result = await (tokenContract.methods.approve(swapContractAddress, String(modifiedValue)).send({
      from: this.state.userAccount
    }));
    console.log(result);
  }

  useSwapContract = async (mode) => {
    let swapContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[this.state.swapPair].contractAddr);

    console.log(this.state.swapDetail.swapOrderID);
    if (mode === "TAKE") {
      let result = await (swapContract.methods.takeSwapOrder(this.state.swapDetail.swapOrderID).send({
        from: this.state.userAccount
      }))
      console.log(result);
    } else if (mode === "CANCEL") {
      let result = await (swapContract.methods.cancelSwapOrder(this.state.swapDetail.swapOrderID).send({
        from: this.state.userAccount
      }))
      console.log(result);
    }
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);

    this.web3 = new Web3(Web3.givenProvider);

    this.web3.eth.requestAccounts()
      .then((result) => {
        //console.log(result);
        this.setState({
          isMetamaskConnected: true,
          userAccount: result[0]
        })
        this.loadSwapDetail();
      })
      .catch((err) => {
        this.setState({
          isMetamaskConnected: false,
          userAccount: ""
        })
      })
  }

  isCallOkay = (mode) => {
    if(mode === "TAKE") {
      if (!this.state.requirements.checkResult[0]) return "⚠️";
      if (!this.state.requirements.checkResult[1]) return "⚠️";
      if (!this.state.requirements.checkResult[2]) return "⚠️";
      if (!this.state.requirements.checkResult[3]) return "⚠️";
    } else {
      console.log(this.state.swapDetail.swapCreator)
      console.log(this.state.userAccount);

      if (this.state.swapDetail.swapCreator !== this.state.userAccount) return "⚠️";
    }
  }

  render() {
    let ftr = Number(Number(this.state.swapDetail.fromTokenAmount) / Number(this.state.swapDetail.toTokenAmount)).toFixed(10); //from : 1 - to : ftr
    let tfr = Number(Number(this.state.swapDetail.toTokenAmount) / Number(this.state.swapDetail.fromTokenAmount)).toFixed(10); //to : 1 - from : tfr

    if (!this.state.isSwapDataLoaded) {
      return (
        <div className="APIS-swapdetail">
          <div className="APIS-swapdetail-container">
            <div className="APIS-swapdetail-loadingcontainer">
              <h1 className="APIS-swapdetail-loading">
                <span className="APIS-swap-intro-text-bold">
                  Loading Swap Order...
                </span>
              </h1>
              <div className="APIS-swapdetail-spinner">
                <SyncLoader
                  size={30}
                  margin={10}
                  color={"#ffffff99"}
                  loading={true}
                />
              </div>
            </div>
          </div>
        </div>
      )
    }

    if (this.state.swapDetail.isSwapCancelled) { //cancelled
      return (
        <div className="APIS-swapdetail">
          <div className="APIS-swapdetail-container">
            <div className="APIS-swapdetail-content-cancelled">
              <h1 className="APIS-swapdetail-head">
                <span className="APIS-swap-intro-text-bold">Cancelled Swap Order </span>{this.props.match.params.pair}-v2-{this.props.match.params.uid}
              </h1>
              <div className="swapdetail-info">
                <p className="swapdetail-title">Swap Information</p>
                <div className="swapdetail-datacontainer">
                  <div className="swapdetail-datacontainer-1">
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap ID</span></p>
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap Status</span></p>
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap Pair</span></p>
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap Creator</span></p>
                  </div>
                  <div className="swapdetail-datacontainer-2">
                    <p className="swapdetail-data">{this.props.match.params.pair}-v2-{this.state.swapDetail.swapOrderID}</p>
                    <p className="swapdetail-data">{this.getSwapStatus()}</p>
                    <p className="swapdetail-data">{this.props.match.params.pair}</p>
                    <p className="swapdetail-data">{this.state.swapDetail.swapCreator}</p>
                  </div>
                </div>

                <p className="swapdetail-title">Swap Ratio 🔄</p>
                <div className="swapdetail-datacontainer">
                  <div className="swapdetail-datacontainer-1">
                    <p className="swapdetail-data">1 <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom} : </span></p>
                    <p className="swapdetail-data">1 <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo} : </span></p>
                  </div>
                  <div className="swapdetail-datacontainer-2">
                    <p className="swapdetail-data">{ftr} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span><br /></p>
                    <p className="swapdetail-data">{tfr} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom}</span></p>
                  </div>
                </div>
                <br />
                <p className="swapdetail-normaldata">
                  Creator will transfer <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.toTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameTo}</span> to Taker
                </p>
                <p className="swapdetail-normaldata">
                  Taker will transfer <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.fromTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameFrom}</span> to Creator
                  (Taker will receive <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.toTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameTo}</span>)
                </p>

                <p className="swapdetail-title">Requirements</p>
                <div className="swapdetail-datacontainer">
                  <div className="swapdetail-datacontainer-1">
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Creator's {this.pairInfo[this.state.swapPair].tokenNameTo} Balance : </span>
                      {this.CC(this.state.requirements.creatorBalance)} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                      {this.state.requirements.checkResult[0] ? " ✔️" : " ❌"}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Creator's {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance : </span>
                      {this.CC(this.state.requirements.creatorAllowance)} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                      {this.state.requirements.checkResult[1] ? "✔️" : "❌"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.state.swapDetail.isSwapOpened) {
      return (
        <div className="APIS-swapdetail">
          <div className="APIS-swapdetail-container">
            <div className="APIS-swapdetail-content">
              <h1 className="APIS-swapdetail-head">
                <span className="APIS-swap-intro-text-bold">Swap Order </span>{this.props.match.params.pair}-v2-{this.props.match.params.uid}
              </h1>
              <div className="swapdetail-info">
                <p className="swapdetail-title">Swap Information</p>
                <div className="swapdetail-datacontainer">
                  <div className="swapdetail-datacontainer-1">
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap ID</span></p>
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap Status</span></p>
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap Pair</span></p>
                    <p className="swapdetail-data"><span className="swapdetail-data-bold">Swap Creator</span></p>
                  </div>
                  <div className="swapdetail-datacontainer-2">
                    <p className="swapdetail-data">{this.props.match.params.pair}-v2-{this.state.swapDetail.swapOrderID}</p>
                    <p className="swapdetail-data">{this.getSwapStatus()}</p>
                    <p className="swapdetail-data">{this.props.match.params.pair}</p>
                    <p className="swapdetail-data">{this.state.swapDetail.swapCreator}</p>
                  </div>
                </div>

                <p className="swapdetail-title">Swap Ratio 🔄</p>
                <div className="swapdetail-datacontainer">
                  <div className="swapdetail-datacontainer-1">
                    <p className="swapdetail-data">1 <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom} : </span></p>
                    <p className="swapdetail-data">1 <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo} : </span></p>
                  </div>
                  <div className="swapdetail-datacontainer-2">
                    <p className="swapdetail-data">{ftr} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span><br /></p>
                    <p className="swapdetail-data">{tfr} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom}</span></p>
                  </div>
                </div>
                <br />
                <p className="swapdetail-normaldata">
                  Creator will transfer <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.toTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameTo}</span> to Taker
                </p>
                <p className="swapdetail-normaldata">
                  Taker will transfer <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.fromTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameFrom}</span> to Creator
                  (Taker will receive <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.toTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameTo}</span>)
                </p>

                <p className="swapdetail-title">Requirements</p>
                <div className="swapdetail-datacontainer">
                  <div className="swapdetail-datacontainer-1">
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Creator's {this.pairInfo[this.state.swapPair].tokenNameTo} Balance : </span>
                      {this.CC(this.state.requirements.creatorBalance)} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                      {this.state.requirements.checkResult[0] ? " ✔️" : " ❌"}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Creator's {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance : </span>
                      {this.CC(this.state.requirements.creatorAllowance)} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                      {this.state.requirements.checkResult[1] ? "✔️" : "❌"}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Taker's {this.pairInfo[this.state.swapPair].tokenNameFrom} Balance (Your {this.pairInfo[this.state.swapPair].tokenNameFrom} Balance) : </span>
                      {this.CC(this.state.requirements.takerBalance)} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom}</span>
                      {this.state.requirements.checkResult[2] ? "✔️" : "❌"}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Taker's {this.pairInfo[this.state.swapPair].tokenNameFrom} Allowance (Your {this.pairInfo[this.state.swapPair].tokenNameFrom} Allowance) : </span>
                      {this.CC(this.state.requirements.takerAllowance)} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom}</span>
                      {this.state.requirements.checkResult[3] ? "✔️" : "❌"}
                    </p>
                    <br />
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">
                        Endpoint-based Requirement Check :
                        {this.state.requirements.checkResult[0] && this.state.requirements.checkResult[1] && this.state.requirements.checkResult[2] && this.state.requirements.checkResult[3]
                          ? "PASS ✔️" : "FAIL ❌"}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="swapdetail-buttondiv">
                  <button className="swapdetail-button button-white" onClick={() => { this.changeAllowance("APPLY", "TO") }}>Apply {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance</button>
                  <button className="swapdetail-button button-white" onClick={() => { this.changeAllowance("APPLY", "FROM") }}>Apply {this.pairInfo[this.state.swapPair].tokenNameFrom} Allowance</button>
                  <button className="swapdetail-button button-white" onClick={() => { this.changeAllowance("REMOVE", "TO") }}>Remove {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance</button>
                  <button className="swapdetail-button button-white" onClick={() => { this.changeAllowance("REMOVE", "FROM") }}>Remove {this.pairInfo[this.state.swapPair].tokenNameFrom} Allowance</button>
                </div>

                <p className="swapdetail-title">Operations</p>
                <div className="swapdetail-buttondiv">
                  <button className="swapdetail-button button-take button-blue" onClick={() => { this.useSwapContract("TAKE") }}>Take Swap {this.isCallOkay("TAKE")}</button>
                  <button className="swapdetail-button button-cancel button-red" onClick={() => { this.useSwapContract("CANCEL") }}>Cancel Swap (Creator-only) {this.isCallOkay("CANCEL")}</button>
                  <div className="swapdetail-buttondiv-dummy"></div>
                  <div className="swapdetail-buttondiv-dummy"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else { //closed
      return (
        <div className="APIS-swapdetail">
          <div className="APIS-swapdetail-container">
            <div className="APIS-swapdetail-content-closed">
              <h1 className="APIS-swapdetail-head">
                Closed Swap Order <span className="APIS-swap-intro-text-bold">{this.props.match.params.pair}-v2-{this.props.match.params.uid}</span>
              </h1>
              <div className="swapdetail-info">
                <p className="swapdetail-title">Swap Information</p>
                <div className="swapdetail-datacontainer">
                  <div>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Swap ID : </span>{this.props.match.params.pair}-v2-{this.state.swapDetail.swapOrderID}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Swap Status : </span> {this.getSwapStatus()}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Swap Pair : </span> {this.props.match.params.pair}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Swap Creator : </span> {this.state.swapDetail.swapCreator}
                    </p>
                    <p className="swapdetail-data">
                      <span className="swapdetail-data-bold">Swap Taker : </span> {this.state.swapDetail.swapTaker}
                    </p>
                    <br />
                    <p className="swapdetail-data">
                      Creator transferred <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.toTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameTo}</span> to Taker
                    </p>
                    <p className="swapdetail-data">
                      Taker transferred <span className="swapdetail-data-bold">{this.CC(this.state.swapDetail.fromTokenAmount)} {this.pairInfo[this.state.swapPair].tokenNameFrom}</span> to Creator
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default SwapDetail;